import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import * as Yup from "yup";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function CommissionModal(props) {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    files: Yup.mixed().required("This field is required!"),
  });

  const handleFileUpload = async (files, accountId) => {
    setLoading(true);

    try {
      for (let i = 0; i < files.length; i++) {
        const response = await axios.post(`/api/commission`, {
          name: files[i].name,
          type: files[i].type,
          account_id: accountId,
        });

        const form_data = new FormData();
        form_data.append("file", files[i], files[i].name);

        await axios.post(
          `/api/commission/${response.data.data.id}/file`,
          form_data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        ).catch((fileErr) => {
          console.log(fileErr);
          context.notification.show(
            "Failed on upload file to server.",
            "error",
            true,
            "toast",
            "x-circle"
          );
        });
      }

      context.notification.show(
        "Commission created successfully!",
        "success",
        true,
        "toast",
        "check-circle"
      );

      if (modal.action) {
        modal.action();
      }
    } catch (err) {
      console.log(err);
      context.notification.show(
        err.response?.data?.message || "An error occurred",
        "error",
        true,
        "toast",
        "x-circle"
      );
    } finally {
      setLoading(false);
      setModal({});
    }
  };

  return (
    <Fragment>
      {modal.name === "commission_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Add Commission</div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  files: "",
                }}
                onSubmit={async () => {
                  const files = document.getElementById("file").files;
                  await handleFileUpload(files, modal.agency_id);
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                  setFieldValue,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="file"
                          type="upload_multiple"
                          label="Files"
                          handleChange={(files) => {
                            handleChange("files");
                            setFieldValue("files", files);
                          }}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.files}
                          touched={touched.files}
                          required
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button className={styles.save} onClick={submitForm}>
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            <>Create</>
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}